import Vue from 'vue'
import SocialCarousel from './components/SocialCarousel'
import Slideout from 'slideout'
import Handorgel from 'handorgel'
const Rellax = require('rellax');
var VueScrollTo = require('vue-scrollto');
const inView = require('in-view');
import VueCarousel from 'vue-carousel';
import CaseStudies from './case-studies';
Vue.use(VueCarousel);




window.Vue = require('vue');

Vue.use(VueScrollTo);

var app = new Vue({
    el: '#app',

    components: {
        SocialCarousel
    }
});

// Parallax
// var scene = document.getElementById('parallax__bg');
// var parallaxInstance = new Parallax(scene);

var rellaxEls = document.getElementsByClassName('rellax');
if(rellaxEls.length) {
    var rellax = new Rellax('.rellax', {
        center: true
    });
}

var rellaxTopEls = document.getElementsByClassName('rellax-top');
if(rellaxTopEls.length) {
    var rellaxTop = new Rellax('.rellax-top', {
        center: false
    });
}

// Phantom Links
const phantomLinks = document.getElementsByClassName('phantom-link');
Array.from(phantomLinks).forEach(link => {
    console.log(link);
    link.addEventListener('click', (e) => {
        let url = link.dataset.link;
        window.location = url;
        e.preventDefault();
    })
});

// Animate numbers
function animateValue(el, start, end, duration) {
    var range = parseInt(end) - parseInt(start);
    var current = parseInt(start);
    var increment = parseInt(end) > parseInt(start)? 1 : -1;
    var stepTime = Math.abs(Math.floor(duration / range));
    var timer = setInterval(function() {
        current += increment;
        el.innerHTML = current;
        if (current == parseInt(end)) {
            clearInterval(timer);
        }
    }, stepTime);
}

const animatedNumberEls = document.getElementsByClassName('animated-number');
Array.from(animatedNumberEls).forEach(el => {
    animateValue(el, el.dataset.start, el.dataset.end, el.dataset.duration)
});

// In Viewport
inView.threshold(0.5);
inView('.in-view-slideup-number')
    .on('enter', el => {
        if(!el.done) {
            setTimeout(() => {
                el.classList.add('in-view--active');
                let numberEl = el.getElementsByClassName('number')[0];
                setTimeout(() => {
                    animateValue(numberEl, el.dataset.start, el.dataset.end, el.dataset.duration);
                }, el.dataset.delay);
            }, el.dataset.indelay);
        }
    })
    .on('exit', el => {
        el.done = true
    });

// Mobile Nav Menus
const slideout = new Slideout({
    'panel': document.getElementById('panel'),
    'menu': document.getElementById('menu'),
    'padding': 256,
    'tolerance': 70,
    'easing': 'cubic-bezier(0.19, 1, 0.22, 1)',
    'duration': 300,
    'side': 'right',
    'touch': false
});

const masthead = document.querySelector('#masthead');
const mobileCloseButton = document.querySelector('#close-mobile-nav');

document.querySelector('#menu-hamburger').addEventListener('click', () => {
    slideout.toggle();
    if(slideout.isOpen()) {
        masthead.classList.add('masthead--slideout');
    } else {
        masthead.classList.remove('masthead--slideout');
    }
});

mobileCloseButton.addEventListener('click', () => {
    slideout.close();
    masthead.classList.remove('masthead--slideout');
});

// Mobile Nav Accordion Menus
for(const el of document.querySelectorAll(".mobile-nav__accordion")) {
    console.log(el);
    new Handorgel(el, {
        headerOpenClass: 'mobile-nav__submenu--open',
        headerOpenedClass: 'mobile-nav__submenu--opened',
    });
}

// Primary nav accordion
const desktopAccordions = [];
for(const el of document.querySelectorAll(".primary-nav__accordion")) {
    let accordion = new Handorgel(el, {
        headerOpenClass: 'primary-nav__submenu--open',
        headerOpenedClass: 'primary-nav__submenu--opened',
    });

    desktopAccordions.push(accordion);

    accordion.on('fold:open', (fold) => {
        desktopAccordions.forEach((accordion) => {
            accordion.folds[0].close();
        });
    })
}

const transparentMashtead = document.querySelector('.masthead--transparent');
if(transparentMashtead) {
    window.addEventListener('scroll', function() {
        if(window.pageYOffset > 200) {
            transparentMashtead.classList.add('masthead--transparent-fill');
        } else {
            transparentMashtead.classList.remove('masthead--transparent-fill');
        }
    });
}



// WEBPACK FOOTER //
// ./source/js/main.js